// eslint-disable-next-line
console.log(
  'Env vars: %s %s %s %s',
  process.env.VUE_APP_BRANCH,
  process.env.VUE_APP_REV,
  process.env.VUE_APP_BUILD_DATE,
  process.env.VUE_APP_API_URL
)

import 'oderon-vue/sass/index.sass'

import Vue from 'vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import './plugins/custom-filters'
import SetTitle from 'oderon-vue/plugins/set-title'
Vue.use(SetTitle)

import MergeQS from 'oderon-vue/plugins/merge-qs'
Vue.use(MergeQS)

import IsMobile from 'oderon-vue/plugins/is-mobile'
Vue.use(IsMobile)

import LoadingPlugin from 'oderon-vue/plugins/loading.js'
Vue.use(LoadingPlugin)

import './plugins/report-pickers'

import { OderonFilters } from 'oderon-vue'
Vue.use(OderonFilters)

import OderonBase from 'oderon-vue/cpts/base.js'
Vue.use(OderonBase)

Vue.config.productionTip = false

const root = new Vue({
  vuetify,
  router,
  render: h => h(App)
})

let base = process.env.VUE_APP_API_URL + '/api/v1'

import { go } from './models'
go.setDefaults({ base })

import TheUser from 'oderon-vue/auth/TheUser'
TheUser.init({ localStorageKey: 'oderon-admin-token' })

root.$mount('#app')
